import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import BasicInformationComponent from '../../BasicInformation'

import { getNumberBase } from '../../../../../../../../../components/FormattedNumber/helpers'
import FormattedNumber from '../../../../../../../../../components/FormattedNumber'
import CustomDate from '../../../../../../../../../components/CustomDate'

import { getArrowTrend } from './helpers'
import { LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'
import './style.scss'

@hocBlock(config.modules.report.key)
@hocConnect
export default class BasicInformation extends Component {
    static propTypes = {
        data: PropTypes.object,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        scrollRefs: PropTypes.object,
        ribbonBlocks: IPropTypes.map,
        scrollTo: PropTypes.func.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true

        return false
    }

    getStyleByValue = (style, value) => {
        if (value < 0) return { ...style, color: '#E00000' }
        return { ...style, color: 'black' }
    }

    getElementsDefinitions = () => {
        const { data } = this.props
        if (!data) return []

        return _.map(_.omit(data, 'empty'), (informations, key) => {
            if (key === 'turnover') {
                const actualValue = informations?.actual?.money?.amount
                const previousValue = informations?.previous?.money?.amount
                const valueRatio =
                    !_.isNil(actualValue) && !_.isNil(previousValue)
                        ? Math.round(((actualValue - previousValue) / Math.abs(actualValue)) * 100)
                        : null

                const amountBase = getNumberBase(actualValue)
                const showMoreDecimalPlaces = actualValue % amountBase?.base !== 0

                return {
                    key,
                    title: <FormattedMessage id={`${LOCALE_PREFIX}.turnoverTitle`} />,
                    top: actualValue ? (
                        <div>
                            <div className={'value-container'}>
                                <div className={`arrow-${getArrowTrend(valueRatio)}`} />
                                <FormattedNumber
                                    displayUnits
                                    displayCurrency
                                    decimalPlaces={showMoreDecimalPlaces ? 2 : 0}
                                    value={actualValue}
                                    currency={_.get(informations, 'actual.money.currency')}
                                    currencyStyle={this.getStyleByValue(
                                        { fontSize: '25px', lineHeight: '25px' },
                                        actualValue
                                    )}
                                    unitsStyle={this.getStyleByValue(
                                        { fontSize: '25px', lineHeight: '25px' },
                                        actualValue
                                    )}
                                    valueStyle={this.getStyleByValue(
                                        { fontSize: '25px', lineHeight: '25px' },
                                        actualValue
                                    )}
                                />
                            </div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.turnoverTopText`} />
                                <CustomDate
                                    date={_.get(informations, 'actual.date.value')}
                                    precision={_.get(informations, 'actual.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    bottom: _.get(informations, 'category.value') ? (
                        <div>
                            <div style={{ fontSize: '18px' }}>{_.get(informations, 'category.value')}</div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.turnoverBottomText`} />
                                <CustomDate
                                    date={_.get(informations, 'category.date.value')}
                                    precision={_.get(informations, 'category.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    tooltip: (
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.turnoverTooltip`}
                            values={{ br: <br />, strong: (chunks) => <strong>{chunks}</strong> }}
                        />
                    ),
                }
            }
            if (key === 'employees') {
                const actualValue = informations?.actual?.value
                const previousValue = informations?.previous?.value
                const valueRatio =
                    !_.isNil(actualValue) && !_.isNil(previousValue)
                        ? Math.round(((actualValue - previousValue) / Math.abs(actualValue)) * 100)
                        : null

                return {
                    key,
                    title: <FormattedMessage id={`${LOCALE_PREFIX}.employeesTitle`} />,
                    top: _.get(informations, 'actual.value') ? (
                        <div>
                            <div className={'value-container'} style={{ fontSize: '25px' }}>
                                <div className={`arrow-${getArrowTrend(valueRatio)}`} />
                                {_.get(informations, 'actual.value')}
                            </div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.employeesTopText`} />
                                <CustomDate
                                    date={_.get(informations, 'actual.date.value')}
                                    precision={_.get(informations, 'actual.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    bottom: _.get(informations, 'category.value') ? (
                        <div>
                            <div style={{ fontSize: '18px' }}>{_.get(informations, 'category.value')}</div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.employeesBottomText`} />
                                <CustomDate
                                    date={_.get(informations, 'category.date.value')}
                                    precision={_.get(informations, 'category.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    tooltip: (
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.employeesTooltip`}
                            values={{ br: <br />, strong: (chunks) => <strong>{chunks}</strong> }}
                        />
                    ),
                }
            }
            if (key === 'profit') {
                const actualValue = informations?.actual?.money?.amount
                const previousValue = informations?.previous?.money?.amount
                const valueRatio =
                    !_.isNil(actualValue) && !_.isNil(previousValue)
                        ? Math.round(((actualValue - previousValue) / Math.abs(actualValue)) * 100)
                        : null

                const amountBase = getNumberBase(actualValue)
                const showMoreDecimalPlaces = actualValue % amountBase?.base !== 0

                return {
                    key,
                    title: <FormattedMessage id={`${LOCALE_PREFIX}.profitTitle`} />,
                    top: actualValue ? (
                        <div>
                            <div className={'value-container'}>
                                <div className={`arrow-${getArrowTrend(valueRatio)}`} />
                                <FormattedNumber
                                    displayUnits
                                    displayCurrency
                                    decimalPlaces={showMoreDecimalPlaces ? 2 : 0}
                                    value={actualValue}
                                    currency={_.get(informations, 'actual.money.currency')}
                                    currencyStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                    unitsStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                    valueStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                />
                            </div>
                            <span>
                                {actualValue >= 0 ? (
                                    <FormattedMessage id={`${LOCALE_PREFIX}.profitTopText`} />
                                ) : (
                                    <FormattedMessage id={`${LOCALE_PREFIX}.lossTopText`} />
                                )}
                                <CustomDate
                                    date={_.get(informations, 'actual.date.value')}
                                    precision={_.get(informations, 'actual.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    bottom: _.get(informations, 'actual.money.amount') ? <div /> : null,
                    tooltip: (
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.profitTooltip`}
                            values={{ br: <br />, strong: (chunks) => <strong>{chunks}</strong> }}
                        />
                    ),
                }
            }

            if (key === 'capital') {
                const actualValue = informations?.actualTotalEquity?.money?.amount
                const previousValue = informations?.previousTotalEquity?.money?.amount
                const valueRatio =
                    !_.isNil(actualValue) && !_.isNil(previousValue)
                        ? Math.round(((actualValue - previousValue) / Math.abs(actualValue)) * 100)
                        : null

                const actualRegisteredValue = informations?.actualRegistered?.money?.amount
                const previousRegisteredValue = informations?.previousRegistered?.money?.amount
                const valueRegisteredRatio =
                    !_.isNil(actualRegisteredValue) && !_.isNil(previousRegisteredValue)
                        ? Math.round(
                              ((actualRegisteredValue - previousRegisteredValue) / Math.abs(actualRegisteredValue)) *
                                  100
                          )
                        : null

                const equityAmountBase = getNumberBase(actualValue)
                const equityShowMoreDecimalPlaces = actualValue % equityAmountBase?.base !== 0

                const registeredAmountBase = getNumberBase(actualRegisteredValue)
                const registeredShowMoreDecimalPlaces = actualRegisteredValue % registeredAmountBase?.base !== 0

                return {
                    key,
                    title: <FormattedMessage id={`${LOCALE_PREFIX}.capitalTitle`} />,
                    top: actualValue ? (
                        <div>
                            <div className={'value-container'}>
                                <div className={`arrow-${getArrowTrend(valueRatio)}`} />
                                <FormattedNumber
                                    displayUnits
                                    displayCurrency
                                    decimalPlaces={equityShowMoreDecimalPlaces ? 2 : 0}
                                    value={actualValue}
                                    currency={_.get(informations, 'actualTotalEquity.money.currency')}
                                    currencyStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                    unitsStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                    valueStyle={this.getStyleByValue({ fontSize: '25px' }, actualValue)}
                                />
                            </div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.capitalTopText`} />
                                <CustomDate
                                    date={_.get(informations, 'actualTotalEquity.date.value')}
                                    precision={_.get(informations, 'actualTotalEquity.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    bottom: actualRegisteredValue ? (
                        <div>
                            <div className={'value-container'}>
                                <div className={`arrow-${getArrowTrend(valueRegisteredRatio)}`} />
                                <FormattedNumber
                                    displayUnits
                                    displayCurrency
                                    decimalPlaces={registeredShowMoreDecimalPlaces ? 2 : 0}
                                    value={actualRegisteredValue}
                                    currency={_.get(informations, 'actualRegistered.money.currency')}
                                    unitsStyle={{ fontSize: '18px' }}
                                    valueStyle={{ fontSize: '18px' }}
                                    currencyStyle={{ fontSize: '18px' }}
                                />
                            </div>
                            <span>
                                <FormattedMessage id={`${LOCALE_PREFIX}.capitalBottomText`} />
                                <CustomDate
                                    date={_.get(informations, 'actualRegistered.date.value')}
                                    precision={_.get(informations, 'actualRegistered.date.precision')}
                                    customStyle={{ paddingLeft: '4px' }}
                                />
                            </span>
                        </div>
                    ) : null,
                    tooltip: (
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.capitalTooltip`}
                            values={{ br: <br />, strong: (chunks) => <strong>{chunks}</strong> }}
                        />
                    ),
                }
            }
            return null
        })
    }

    handleOnItemCLick = () => {
        const { scrollTo, scrollRefs, ribbonBlocks } = this.props

        if (scrollRefs.velikost && ribbonBlocks.get('velikost')) scrollTo(scrollRefs.velikost)
    }

    render() {
        return (
            <div className={cx('block-basic-information')}>
                <BasicInformationComponent
                    elementsDefinitions={this.getElementsDefinitions()}
                    clickHandler={this.handleOnItemCLick}
                    mainId={this.props.id}
                />
            </div>
        )
    }
}
